
<h1 *ngIf="displayHeader" class="page-header"><i class="fa fa-star" aria-hidden="true"></i> PEOPLE</h1>

<!-- Main Screen which shows the People Objects and People Instances -->
<div class="infrastructure-tabs" id="objectContentPane">

  <!-- Tab Navigation Control -->
  <ul class="nav nav-tabs">
    <li class="active"><a data-toggle="tab" href="#people-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> PEOPLE</a></li>
    <li><a data-toggle="tab" href="#people-objects-tab" aria-expanded="false"><i class="fa fa-star-o"></i> PEOPLE TYPES</a></li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content">

    <!-- People Objects Tab -->
    <div id="people-objects-tab" class="tab-pane fade">

      <!-- Add People Type and Options buttons -->
      <button (click)="addPeopleClicked()" type="button" class="btn btn-primary"><em class="fa fa-plus"></em> ADD PEOPLE
        TYPE</button>
      <div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"><em class="fa fa-th"></em>
          OPTIONS <span class="caret"></span></button>
        <ul class="dropdown-menu">
          <li (click)="editSelectedPeopleClicked()" [class.disabled]="!isSinglePeopleTypeSelected()"><a><em
                class="fa fa-pencil"></em> EDIT</a></li>
          <li (click)="duplicateSelectedPeopleClicked()" [class.disabled]="!isSinglePeopleTypeSelected()"><a><em
                class="fa fa-clone"></em> DUPLICATE</a></li>
          <li (click)="deleteSelectedPeopleClicked()" [class.disabled]="!isAnyPeopleTypesSelected()"><a><em
                class="fa fa-remove"></em> DELETE</a></li>
          <li class="divider"></li>
          <li (click)="addPeopleTypesToGroupClicked()" [class.disabled]="!isAnyPeopleTypesSelected()"><a><em
                class="fa fa-plus"></em> ADD TO GROUP</a></li>
          <li (click)="removePeopleTypesFromGroupClicked()" [class.disabled]="!isAnyPeopleTypesSelected()"><a><em
                class="fa fa-remove"></em> REMOVE FROM GROUP</a></li>
          <li (click)="managePeopleTypeGroups()"><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a></li>
          <li class="divider"></li>
          <li (click)="uploadTypeFileClicked()"><input type="file" #typeFileUpload
              (change)="onTypeFileUploadChange($event)" style="display:none" /><a><em class="fa fa-upload"></em> UPLOAD
              TYPES </a></li>
          <li (click)="downloadTypes()"><a><em class="fa fa-download"></em> DOWNLOAD TYPES </a></li>
          <li (click)="downloadPeople()" [class.disabled]="!isSinglePeopleTypeSelected()"><a><em
                class="fa fa-download"></em> DOWNLOAD PEOPLE </a></li>
        </ul>
      </div>

			<!-- "Filter" Button w/ drop down options -->
			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
					<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
				</button>
				<ul class="dropdown-menu">
					<li *ngFor="let filterOption of filterOptionsForTypes" (click)="onFilterOptionForTypesClicked(filterOption)">
						<a>{{ filterOption.label }}</a>
					</li>
				</ul>
			</div>

			<!-- Filter Label (if a Filter Option is selected) -->
			<div *ngIf="filterOptionForTypes?.column != null" 
				class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				{{ filterOptionForTypes.label }}
			</div>

			<!-- Filter Value (if a Filter Option is selected)-->
			<div *ngIf="filterOptionForTypes?.column != null" 
				class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
					[(ngModel)]="filterValueForTypes"
					(ngModelChange)="onFilterValueForTypesChanged()">
			</div>

			<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
				<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
						class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
						<ul class="dropdown-menu">
							<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
								<a>{{ value }}</a>
							</li>
						</ul>
			</div>

      <!-- People Objects -->
      <table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid"
        role="grid">
        <thead>
          <tr role="row" class="tablesorter-headerRow">
            <th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col"
              role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
              aria-label=": No sort applied, activate to apply an ascending sort" style="user-select: none;">
              <div class="tablesorter-header-inner">
                <div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
                    [checked]="isAllPeopleTypesSelected()" (change)="setAllPeopleTypesSelected($event)"><label
                    for="checkbox"></label></div>
              </div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
              data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
              aria-disabled="false" aria-controls="table1" aria-sort="none"
              aria-label="Name: No sort applied, activate to apply an ascending sort">
              <div class="tablesorter-header-inner">Name</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
              data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col" role="columnheader"
              aria-disabled="false" aria-controls="table1" aria-sort="none"
              aria-label="Groups: No sort applied, activate to apply an ascending sort">
              <div class="tablesorter-header-inner">Groups</div>
            </th>
          </tr>
        </thead>
        <tbody aria-live="polite" aria-relevant="all">
          <ng-container
            *ngFor="let peopleTypeUi of mPeopleTypeUis | paginate: {id: 'peopletype_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForTypes, totalItems: totalNumberOfTypes }">
            <tr class="" role="row">
              <td>
                <div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
                    [(ngModel)]="peopleTypeUi.mSelected"><label for="checkbox"></label></div>
              </td>
              <td (click)="editPeople(peopleTypeUi.mPeopleType)">{{peopleTypeUi.mPeopleType.name}}</td>
              <td>
                <ng-container
                  *ngIf="peopleTypeUi.mPeopleType.groups != null && peopleTypeUi.mPeopleType.groups.length > 0">
                  <ng-container *ngFor="let group of peopleTypeUi.mPeopleType.groups">
                    <button class="groupButton" (click)="showGroup(group)">{{group.name}}</button>
                  </ng-container>
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

			<!-- Pagination Controls for the "People" Types (controls referenced in the *ngFor for the table data above) -->
			<pagination-controls class="pagination" id="peopletype_pagination" (pageChange)="onTypePageChange($event)"
				[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
			</pagination-controls>
    </div>



    <!-- People Instances Tab -->
    <div id="people-instances-tab" class="tab-pane fade active in">

      <!-- Add People and Options buttons -->
      <button (click)="addPeopleInstanceClicked()" type="button" class="btn btn-primary"><em class="fa fa-plus"></em>
        ADD PEOPLE</button>
      <div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"><em class="fa fa-th"></em>
          OPTIONS <span class="caret"></span></button>
        <ul class="dropdown-menu">
          <li (click)="editSelectedPeopleInstanceClicked()" [class.disabled]="!isSinglePeopleInstanceSelected()"><a><em
                class="fa fa-pencil"></em> EDIT</a></li>
          <li (click)="duplicateSelectedPeopleInstanceClicked()" [class.disabled]="!isSinglePeopleInstanceSelected()">
            <a><em class="fa fa-clone"></em> DUPLICATE</a>
          </li>
          <li (click)="deleteSelectedPeopleInstancesClicked()" [class.disabled]="!isAnyPeopleInstancesSelected()"><a><em
                class="fa fa-remove"></em> DELETE</a></li>
          <li class="divider"></li>
          <li (click)="addPeopleInstancesToGroupClicked()" [class.disabled]="!isAnyPeopleInstancesSelected()"><a><em
                class="fa fa-plus"></em> ADD TO GROUP</a></li>
          <li (click)="removePeopleInstancesFromGroupClicked()" [class.disabled]="!isAnyPeopleInstancesSelected()">
            <a><em class="fa fa-remove"></em> REMOVE FROM GROUP</a>
          </li>
          <li (click)="managePeopleInstanceGroups()"><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a></li>
          <li class="divider"></li>
          <li (click)="uploadInstanceFileClicked()"><input type="file" #fileInstanceUpload
              (change)="onInstanceFileUploadChange($event)" style="display:none" /><a><em class="fa fa-upload"></em>
              UPLOAD PEOPLE </a></li>
        </ul>
      </div>

			<!-- "Filter" button w/ drop down options -->
      <div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
        <button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
          <em class="fa fa-filter"></em> FILTER <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li *ngFor="let filterOption of filterOptionsForInstances" (click)="onFilterOptionForInstancesClicked(filterOption)">
            <a>{{ filterOption.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Filter Label (if a Filter Option is selected) -->
      <div *ngIf="filterOptionForInstances?.column != null" 
        class="dropdown btn-group edgefinityHeader" style="display:inline-block">
        {{ filterOptionForInstances.label }}
      </div>

      <!-- Filter Value (if a Filter Option is selected)-->
      <div *ngIf="filterOptionForInstances?.column != null" 
        class="dropdown btn-group edgefinityHeader" style="display:inline-block">
        <input class="form-control ng-pristine ng-valid ng-untouched" type="text"
          [(ngModel)]="filterValueForInstances"
          (ngModelChange)="onFilterValueForInstancesChanged()">
      </div>

      <div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
        <button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
            class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
            <ul class="dropdown-menu">
              <li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
                <a>{{ value }}</a>
              </li>
            </ul>
      </div>


      <!-- People Instances -->
      <table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid"
        role="grid">
        <thead>
          <tr role="row" class="tablesorter-headerRow">
            <th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col"
              role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
              aria-label=": No sort applied, activate to apply an ascending sort" style="user-select: none;">
              <div class="tablesorter-header-inner">
                <div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
                    [checked]="isAllPeopleInstancesSelected()" (change)="setAllPeopleInstancesSelected($event)"><label
                    for="checkbox"></label></div>
              </div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
              data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
              aria-disabled="false" aria-controls="table1" aria-sort="none" aria-label="Image">
              <div class="tablesorter-header-inner">&nbsp;Image</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
              data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
              aria-disabled="false" aria-controls="table2" aria-sort="none"
              aria-label="Name: No sort applied, activate to apply an ascending sort">
              <div class="tablesorter-header-inner">Name</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
              data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col" role="columnheader"
              aria-disabled="false" aria-controls="table2" aria-sort="none"
              aria-label="People Type: No sort applied, activate to apply an ascending sort">
              <div class="tablesorter-header-inner">People Type</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
              data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col" role="columnheader"
              aria-disabled="false" aria-controls="table2" aria-sort="none"
              aria-label="Groups: No sort applied, activate to apply an ascending sort">
              <div class="tablesorter-header-inner">Groups</div>
            </th>
          </tr>
        </thead>
        <tbody aria-live="polite" aria-relevant="all">
          <ng-container
            *ngFor="let peopleInstanceUi of mPeopleInstanceUis | paginate: {id: 'peopleinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForInstances, totalItems: totalNumberOfInstances }">
            <tr class="" role="row">
              <td>
                <div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
                    [(ngModel)]="peopleInstanceUi.mSelected"><label for="checkbox"></label></div>
              </td>
              <td (click)="editPeopleInstance(peopleInstanceUi.mPeopleInstance)"><img
                  [src]="getPathForPersonImage(peopleInstanceUi.mPeopleInstance)" width="80"></td>
              <td (click)="editPeopleInstance(peopleInstanceUi.mPeopleInstance)"  (contextmenu)="fetchFunctionList($event, peopleInstanceUi.mPeopleInstance)">
                {{peopleInstanceUi.mPeopleInstance.name}}</td>
              <td (click)="editPeopleInstance(peopleInstanceUi.mPeopleInstance)">
                {{peopleInstanceUi.mPeopleInstance.object.name}}</td>
              <td>
                <ng-container
                  *ngIf="peopleInstanceUi.mPeopleInstance.groups != null && peopleInstanceUi.mPeopleInstance.groups.length > 0">
                  <ng-container *ngFor="let group of peopleInstanceUi.mPeopleInstance.groups">
                    <button class="groupButton" (click)="showGroup(group)">{{group.name}}</button>
                  </ng-container>
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

			<!-- Pagination Controls for the "People" Instances (controls referenced in the *ngFor for the table data above) -->
			<pagination-controls class="pagination" id="peopleinstance_pagination"
					(pageChange)="onInstancePageChange($event)" [directionLinks]="true"
					nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

    </div>
  </div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
  [entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()" (showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance" 
  [instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [objectCategory]="mObjectCategory"
  [instanceType]="mInstanceType" [instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
  [selectedTags]="mSelectedTags" [availableTags]="mAvailableTags" (createOrUpdateEvent)="createOrUpdateEntityInstance()"
  (showGroup)="showGroup($event)" (selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
  (refreshInstanceDataEvent)="refreshInstanceData()" (selectedTagChangedEvent)="selectedTagChanged($event)">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<!-- Right Click dropdown menu -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
  [items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance" [instanceType]="mInstanceType"
  [function]="selectedFunction"></app-general-function-dialog>

<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>